export default __webpack_public_path__ + "static/media/bgbg.7c1e1b6d.png";